import { yupResolver } from "@hookform/resolvers/yup"
import React, { useEffect } from "react"
import { useForm } from "react-hook-form"
import Modal from "../../components/modal"
import * as Yup from "yup"
import { FormInput } from "../../wrappers/formInput"
import { DropDownInput } from "../../wrappers/selectInput"
import { PhoneInput } from "../../wrappers/phoneInput"
import Button from "../../components/button"
import FormHead from "../../components/headings/FromHead"

export type AddUserForm = {
  firstName: string
  lastName: string
  designation: string
  email: string
  phone: string
}

interface Props {
  onClose?: any
  clickHandler?: any
  defaultValues?: any
}

const validationSchema = Yup.object({
  firstName: Yup.string().required("Field is Required"),
  lastName: Yup.string().required("Field is Required"),
  designation: Yup.string().required("Field is Required"),
  email: Yup.string().required("Field is required").email("Please provide a valid email address").nullable(true)
})

const AddUser: React.FC<Props> = ({ onClose, clickHandler, defaultValues }) => {
  
  const formOptions = {
    resolver: yupResolver(validationSchema)
  }

  const { register, handleSubmit, control, setValue, formState } = useForm<AddUserForm>(formOptions)

  useEffect(() => {
    
    if (defaultValues) {
      setValue("firstName", defaultValues.firstName);
      setValue("lastName", defaultValues.lastName);
      setValue("designation", defaultValues.designation);
      setValue("email", defaultValues.email);
      setValue("phone", defaultValues.phone && defaultValues.phone.toString()
      )
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues])
  
  return (
    <div>
      <Modal title={"Add User "} size="medium" onClose={onClose}>
        <form>
          <FormHead>Add User</FormHead>
          <div className="half-form-wrap">
            <div className="form-group">
              <FormInput<AddUserForm>
                name="firstName"
                register={register}
                errors={formState.errors}
                label="First Name*"
                placeholder="First Name"
                type="text"
              />
            </div>
            <div className="form-group">
              <FormInput<AddUserForm>
                name="lastName"
                type="text"
                register={register}
                errors={formState.errors}
                label="Last Name*"
                placeholder="Last Name"
              />
            </div>
          </div>
          <div className="half-form-wrap">
            <div className="form-group">
              <DropDownInput<AddUserForm>
                name="designation"
                register={register}
                errors={formState.errors}
                label="Designation*"
                control={control}
                data={["Recruiter", "C level", "Manager"]}
              />
            </div>
            <div className="form-group">
              <FormInput<AddUserForm>
                name="email"
                type="text"
                register={register}
                errors={formState.errors}
                label="Email*"
                placeholder="you@example.com"
              />
            </div>
          </div>
          <div className="half-form-wrap">
            <div className="form-group">
              <PhoneInput<AddUserForm>
                name="phone"
                label="Phone Number"
                register={register}
                errors={formState.errors}
                control={control}
              />
            </div>
          </div>
          <div className="popupAction">
            <Button variant="secondary" onClick={onClose}>Cancel</Button>
            <Button variant="primary" onClick={handleSubmit(clickHandler)}>Save</Button>
          </div>
        </form>
      </Modal>
    </div>
  )
}
export default AddUser
